import BigNumber from 'bignumber.js';
import { DlVault } from 'types/contracts';

export interface GetNetworkRewardDetailsInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetNetworkRewardDetailsOutput = {
  rewardsByLevel: BigNumber[];
  usersByLevel: number[];
  totalNetworkReward: BigNumber;
  potentialReward: BigNumber;
};

const getNetworkRewardDetails = async ({
  dlVaultContract,
  accountAddress,
}: GetNetworkRewardDetailsInput): Promise<GetNetworkRewardDetailsOutput> => {
  const result = await dlVaultContract.methods
    .getNetworkRewardDetails(accountAddress)
    .call();

  return {
    rewardsByLevel: Array.isArray(result.rewardsByLevel)
      ? result.rewardsByLevel.map((reward: string) => new BigNumber(reward))
      : [],
    usersByLevel: Array.isArray(result.usersByLevel)
      ? result.usersByLevel.map((count: string) => parseInt(count, 10))
      : [],
    totalNetworkReward: new BigNumber(result.totalNetworkReward || '0'),
    potentialReward: new BigNumber(result.potentialReward || '0'),
  };
};

export default getNetworkRewardDetails; 